

import { Component, Vue, Prop} from 'vue-property-decorator';
import { Question } from "survey-vue";
import * as SurveyVue from "survey-vue"; 

@Component
export default class AdvancedRadioGroupWithDescription extends Vue {
    
    @Prop({required: true})
    question!: Question
 
    textBefore = [];
    textAfter = [];
    inputWidths = [];    
    inputTypes = [];
    inputNames = [];
    radioOutputValues = [];
    textClass = [];
    radioMargins='';
    radioTextMargins='';
    hasOther = false;
    otherText = '';

    maxChar=0;
    
    numberOfRows = 0;

    readOnly = false; 

    pendingValue = {}
    
    fields =[];

    dataReady = false;

    mounted(){ 
        this.dataReady = false ;
        this.radioOutputValues = this.splitData(this.question.radioOutputValues)
        this.textBefore = this.splitData(this.question.textBeforeInputs)
        this.textAfter = this.splitData(this.question.textAfterInputs)
        this.inputWidths = this.splitData(this.question.inputWidths)
        this.inputTypes = this.splitData(this.question.inputTypes)
        this.inputNames = this.splitData(this.question.inputNames)
        this.textClass = this.question.textClass;
        this.maxChar = this.question.maxChar || 10000;
        this.radioMargins = this.question.radioMargins;
        this.radioTextMargins = this.question.radioTextMargins;
        this.hasOther = this.question.hasOther || false;
        this.otherText = this.question.otherText || 'Other (describe)';

        this.numberOfRows = this.inputTypes.length
        this.readOnly = this.question.readOnly;
        
        this.fields = this.makeFields()
        this.pendingValue = Object.assign({}, this.question.value)

        this.questionValidator();
        this.dataReady = true
    }

    public questionValidator(){
        this.question.validateValueCallback = () => {
            let row = 2;
            
            if(!this.pendingValue['selected']){
                    return( new SurveyVue.SurveyError("Please select an option"))
            }else if(this.pendingValue['selected'] == 'other'){
                row = this.numberOfRows -1
            }else{
                row = this.radioOutputValues[0].indexOf(this.pendingValue['selected'])
                if(this.textBefore[row].length<2 || this.textAfter[row].length<2) return null
            }            
            let error = null      
            for (const field of this.fields[row]) {
                const newValue = (this.pendingValue[field.name] || "").trim();

                if (!newValue ||(newValue && !newValue.length)){
                    error = new SurveyVue.SurveyError("Please enter all fields")

                    break;
                }                
            }
            return error
        }
    }

    public splitData(data){
        const dataInput = data.substring(1).slice(0, -1);
        const inputRows = dataInput.split('};{');
        const dataOutput = [];
        for(const inputRow of inputRows)
            dataOutput.push(inputRow.split('},{'))

        return dataOutput
    }

    public inputChanged(){

        const currentVal = this.question.value || {};
        let updatedVal = {};
        let emptyField = true;
        let valueChanged = false;

        for(let j=0; j<this.numberOfRows; j++){
            for (const field of this.fields[j]) {
                const newValue = (updatedVal[field.name] = (this.pendingValue[field.name] || "").trim());
                if (newValue.length) emptyField = false;
                if ((currentVal[field.name] || "") !== newValue) valueChanged = true;
            }
        }
        if (valueChanged) this.question.value = emptyField ? null : updatedVal;

    }

    public makeFields() {

        const fields = []
        const generalId = this.question.inputId;
        for(let j=0; j<this.numberOfRows; j++){
            const fieldRows = [];
            const inputname = this.inputNames[j]
            for(const inx in inputname){
                fieldRows.push(
                {
                    name: inputname[inx],
                    id: generalId +"-"+inputname[inx].toLowerCase() ,                
                })            
            }
            fields.push(fieldRows)
        } 
        const fieldRow = [{name:'selected', id:generalId +'-selected'}];
        if(this.hasOther) fieldRow.push({name:'otherComment', id:generalId +'-other-comment'})
        fields.push(fieldRow)
        this.numberOfRows++; 
        return fields;
    }
            /* Example
            {
              "type": "advancedradiogroup",
              "name": "paymentRequestStartingDate",              
              "title": "When do you want the child support payments to start?",
              "description" : "You need to tell the court .",
              "radioOutputValues":"{ExactDate},{FreeComment}",
              "inputNames":"{startingDate};{lawyerName},{clientName}",
              "inputTypes":"{date};{text},{text}",
              "inputWidths":"{12rem};{10rem},{9rem}",                  
              "textBeforeInputs":"{Enter exact date:},{};{I},{, the lawyer for},{, acknowledge it.}",
              "textAfterInputs":"{Enter exact date:},{};{I},{, the lawyer for},{, acknowledge it.}",
              "textClass": "sv_q_title font-weight-bold",
              "radioMargins":"0 0 1rem 0",
              "radioTextMargins":"-0.6rem 0 0 0",
              "hasOther": true,
              "isRequired": true
            },
            */     
}
